import { useState, useRef } from "react";
import * as Dnd from "react-dnd";
import { DeleteIcon, EditIcon } from "@chakra-ui/icons";

import ButtonUI from "../../../ButtonUI";
import { FormElement } from "../../Elements";

import ItemTypes from "./ItemTypes";

import classes from "./css/sortable-elements.module.css";
const SortableElement = ({
  element,
  index,
  onMove,
  onEdit,
  onDelete,
  readOnly,
}) => {
  const ref: any = useRef(null);
  const [showAction, setShowAction] = useState(false);
  const [{ handlerId }, drop] = Dnd.useDrop({
    accept: ItemTypes.BOX,
    collect(monitor) {
      return {
        handlerId: monitor.getHandlerId(),
      };
    },
    hover(item: any, monitor) {
      if (!ref.current) {
        return;
      }
      const dragIndex = item.index;
      const hoverIndex = index;
      // Don't replace items with themselves
      if (dragIndex === hoverIndex) {
        return;
      }
      // Determine rectangle on screen
      const hoverBoundingRect = ref.current?.getBoundingClientRect();
      // Get vertical middle
      const hoverMiddleY =
        (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
      // Determine mouse position
      const clientOffset: any = monitor.getClientOffset();
      // Get pixels to the top
      const hoverClientY = clientOffset.y - hoverBoundingRect.top;
      // Only perform the move when the mouse has crossed half of the items height
      // When dragging downwards, only move when the cursor is below 50%
      // When dragging upwards, only move when the cursor is above 50%
      // Dragging downwards
      if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
        return;
      }
      // Dragging upwards
      if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
        return;
      }
      // Time to actually perform the action
      onMove(dragIndex, hoverIndex);

      item.index = hoverIndex;
    },
  });
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [{ isDragging }, drag, preview] = Dnd.useDrag({
    type: ItemTypes.BOX,
    item: () => {
      return { id: element.id, index: index };
    },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });
  const editHandler = () => {
    if (onEdit) onEdit(element, index);
  };
  const deleteHandler = () => {
    if (onDelete) onDelete(element, index);
  };


  drag(drop(ref));

  return (
    <div
      ref={preview}
      className={
        "flex flex-start shadow mb-1 mt-5 relative border border-blue-400  border-dashed rounded-lg hover:border-white hover:bg-gray-100 p-4  "
      }
      data-handler-id={handlerId}
      onMouseOver={() => setShowAction(true)}
      onMouseOut={() => setShowAction(false)}
    >
      <div className={classes.sorter} ref={ref}>
        <i
          className="fas fa-grip-vertical"
          style={{ margin: "10px", color: "#ccc" }}
        ></i>
      </div>
      <div className={classes.formitem}>
        <FormElement form={undefined} readOnly={readOnly} element={element} />
      </div>
      <div
        className={classes.action}
        style={{ display: showAction ? "block" : "none" }}
      >
        <ButtonUI status="icon-primary" className="mx-2 " onClick={editHandler}>
          <EditIcon color="white" />
        </ButtonUI>
        <ButtonUI
          status="icon-secondary"
          className="mx-2"
          onClick={deleteHandler}
        >
          <DeleteIcon color="red.300" />
        </ButtonUI>
      </div>
    </div>
  );
};
export default SortableElement;
